import { UserAmilearnStatus } from '../user/user.type';

export type GtmEvent =
  | 'start_registration'
  | 'join_now'
  | 'submit_registration'
  | 'contact_sales'
  | 'contact_support'
  | 'footer_connect_email'
  | 'app_error'
  | 'subscription_payment_start'
  | 'login'
  ; 

export type GtmUserOrigin = 'MSAW' | 'WWW';

export const GTM_UNKNOWN_DATA = 'UNKNOWN';

export type GtmEventCategory = 'Button Click' | 'Link Click';

export type GtmEventAction = 'Outbound Link' | 'Form Submit' | 'Scroll' | 'Login Attempt';

export type GtmLoginMethod = 'email_password' | 'sso';

type GtmComponent = 'AmiLearn Portal';
export const GTM_DEFAULT_COMPONENT = 'AmiLearn Portal';

export type GtmEventData = {
  component: GtmComponent;
  category: GtmEventCategory;
  action: GtmEventAction;
  element: string;
  user_origin: GtmUserOrigin;
  amilearn_user_status: GtmUserAmilearnStatus;
  amilearn_ms_region_id: string;
  method?: GtmLoginMethod;
};

export type GtmUserDetails = Pick<
  GtmEventData,
  'user_origin' | 'amilearn_user_status' | 'amilearn_ms_region_id'
>;

export type EventData = Omit<GtmEventData, 'component' | keyof GtmUserDetails>;

export enum UserAmilearnStatusUnknown {
  UNKNOWN = 'UNKNOWN',
}

export type GtmUserAmilearnStatus =
  | UserAmilearnStatus
  | UserAmilearnStatusUnknown;
